import {LOGIN_FLOW_PAGES_ERROR_SHAKE_COUNT, LOGIN_FLOW_PAGES_ERROR_SHAKE_PERIOD, LOGIN_FLOW_PAGES_ERROR_SHAKE_DURATION} from '../constants';

const showMessage = (messageBlockId, messageTextId, messageText) => {
  const messageContainer = document.getElementById(messageBlockId),
      messageTextField = document.getElementById(messageTextId),
      isMessageAlreadyVisible = messageTextField.textContent;

  messageTextField.textContent = messageText;

  if (isMessageAlreadyVisible) {
    $(messageContainer).shake(LOGIN_FLOW_PAGES_ERROR_SHAKE_COUNT, LOGIN_FLOW_PAGES_ERROR_SHAKE_PERIOD, LOGIN_FLOW_PAGES_ERROR_SHAKE_DURATION);
  } else {
    messageContainer.classList.add('show-delay-500');
    messageContainer.classList.remove('infobox--hidden');
  }
}

export {showMessage}
